import React from "react";
import { LegalPage } from "@/components/LegalPage";

export default function Privacy() {
  return <LegalPage docKey="privacy" testId="legal-privacy-screen" />;
}
